import { CSSProperties } from 'react';

import { bodyWidth } from 'constants/values';

export const container: CSSProperties = {
  backgroundColor: '#fff',
  width: '100%',
};

export const body: CSSProperties = {
  backgroundColor: '#fff',
  height: 620,
  margin: 'auto',
  position: 'relative',
  width: bodyWidth,
};

export const image1: CSSProperties = {
  height: 173,
  left: 207,
  position: 'absolute',
  top: 276,
  width: 1016,
};

export const image21: CSSProperties = {
  height: 56,
  left: 208,
  position: 'absolute',
  top: 393,
  width: 106,
};

export const image22: CSSProperties = {
  height: 150,
  left: 489,
  position: 'absolute',
  top: 299,
  width: 169,
};

export const image23: CSSProperties = {
  height: 86,
  left: 725,
  position: 'absolute',
  top: 276,
  width: 200,
};

export const image24: CSSProperties = {
  height: 71,
  left: 1024,
  position: 'absolute',
  top: 275,
  width: 199,
};

export const aImage1: CSSProperties = {
  height: 133,
  width: 57,
};

export const aPos1: CSSProperties = {
  left: 237,
  position: 'absolute',
  top: 285,
};

export const aPos2: CSSProperties = {
  left: 544,
  position: 'absolute',
  top: 210,
};

export const aPos3: CSSProperties = {
  left: 852,
  position: 'absolute',
  top: 201,
};

export const aPos4: CSSProperties = {
  left: 1156,
  position: 'absolute',
  top: 187,
};
